<div class="prompt-dialog">
    <div class="prompt-header">
        <div class="prompt-header-text">
            {{dialogParams.title}}
        </div>
        <div class="xs-dialog-close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top" (click)="onCancel()"></div>
    </div>
    <div class="dialog-header-separator"></div>
    <div class="prompt-body">
      <form [formGroup]="form" spellcheck="false" autocorrect="off">
                <div class="prompt-description">{{dialogParams?.inputTitle}}</div>
                <div class="prompt-input" *ngIf="dialogParams.regexFilter">
                    <app-text-input
                        class="hd-field-input"
                        [inputFormControl]="fileName"
                     ></app-text-input>
                    <div class="prompt-extension" *ngIf="dialogParams.extension">{{dialogParams?.fileParams.extension}}</div>
                </div>
                <div class="error-label" *ngIf="!isValid()">{{getErrorMessage()}}</div>
      </form>
    </div>
    <div class="modal-footer">
        <button class="xs-btn btn-outline btn-space" type="button" (click)="onCancel()">
            <span>{{'xs_cancel_label_short' | xsI18n}}</span>
        </button>
        <button [disabled]="!isValid()" class="xs-btn btn-primary" type="button" (click)="confirm()">
            <span>{{dialogParams?.confirmButton}}</span>
        </button>
    </div>
</div>
